import classNames from "classnames";
import { Button } from "components/DesignSystem/Button/Button";
import { Cross } from "components/icons/Cross";
import { PlusIcon } from "components/icons/PlusIcon";

type PastYearsCardProps = {
  years: number[];
  selectedYears: number[];
  entityName: string;
  onAddYear: (year: number) => void;
  onRemoveYear: (year: number) => void;
};

export const PastYearsCard = ({
  years,
  selectedYears,
  entityName,
  onAddYear,
  onRemoveYear,
}: PastYearsCardProps) => {
  return (
    <div className="dashed-border-purple t-flex t-flex-col t-gap-1.5 t-rounded-xl t-bg-white t-px-5 t-py-3">
      <span className="t-text-body-sm-lite t-text-text-30">
        Select any previous tax years you'd like us to prepare filings for
      </span>

      <div className="t-flex t-flex-wrap t-gap-3 t-pt-1">
        {years.map((year) => {
          const isSelected = selectedYears.includes(year);

          const yearClassName = classNames({
            "!t-border-purple-20 !t-bg-surface-purple": isSelected,
          });

          const handleClick = () =>
            isSelected ? onRemoveYear(year) : onAddYear(year);

          return (
            <Button
              key={year}
              customType="secondary"
              size="xsmall"
              leftIcon={isSelected ? undefined : <PlusIcon size="12" />}
              rightIcon={
                isSelected ? (
                  <Cross size="12" color="currentColor" />
                ) : undefined
              }
              className={yearClassName}
              onClick={handleClick}
            >
              {year}
            </Button>
          );
        })}
      </div>
    </div>
  );
};
